(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["geosort-accordion-motion"] && !Shopify.designMode) return;
  try {
    (()=>{
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations=new Map();
  function init(root){
    if(root.dataset.gcAccordionReady)return;
    root.dataset.gcAccordionReady='true';
    root.querySelectorAll('details').forEach(details=>{
      const summary=details.querySelector('summary');
      const answer=details.querySelector('[data-gc-accordion-body]');
      function sync(){
        summary.setAttribute('aria-expanded',String(details.open));
        answer.inert=!details.open;
        answer.setAttribute('aria-hidden',String(!details.open));
      }
      sync();
      details.addEventListener('toggle',()=>{if(!animations.has(details))sync();});
      summary.addEventListener('click',event=>{
        event.preventDefault();
        const expanded=summary.getAttribute('aria-expanded')!=='true';
        const height=details.getBoundingClientRect().height;
        const previous=animations.get(details);
        if(previous){previous.cancel();animations.delete(details);}
        const finish=()=>{
          details.open=expanded;
          details.style.removeProperty('overflow');
          animations.get(details)?.cancel();
          animations.delete(details);
          sync();
        };
        if(motion.matches||!details.animate){finish();return;}
        // Native details must stay open until the closing animation has finished.
        details.open=true;
        summary.setAttribute('aria-expanded',String(expanded));
        answer.inert=!expanded;
        answer.setAttribute('aria-hidden',String(!expanded));
        const style=getComputedStyle(details);
        const border=parseFloat(style.borderTopWidth)+parseFloat(style.borderBottomWidth);
        const target=expanded?details.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
        details.style.overflow='hidden';
        const animation=details.animate([{height:`${height}px`},{height:`${target}px`}],{
          duration:300,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'
        });
        animations.set(details,animation);
        animation.onfinish=finish;
      });
    });
  }
  motion.addEventListener('change',()=>{if(motion.matches)animations.forEach(animation=>animation.finish());});
  document.querySelectorAll('[data-gc-accordion-root]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-gc-accordion-root]').forEach(init));
  document.addEventListener('shopify:section:unload',event=>{
    animations.forEach((animation,details)=>{if(event.target.contains(details)){animation.cancel();animations.delete(details);}});
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["geosort-features-layers-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    const cleanups = new WeakMap();
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const list=root.querySelector('[data-layer-list]'),preview=root.querySelector('[data-layer-products]');
      const layers=[...list.querySelectorAll('[data-layer]')],products=[...preview.children];
      const scopes=[...root.querySelectorAll('[data-layer-scope]')];
      const scopeBar=root.querySelector('.gflh-scopes');
      const view=root.querySelector('[data-layer-view]');
      const dialog=root.querySelector('[data-group-dialog]'),groupForm=root.querySelector('[data-group-form]');
      const countryDialog=root.querySelector('[data-country-dialog]'),countryForm=root.querySelector('[data-country-form]');
      const create=root.querySelector('[data-layer-create]'),members=root.querySelector('[data-group-members]');
      const countrySelect=root.querySelector('[data-layer-countries]'),announcement=root.querySelector('[data-layer-announcement]');
      const createGroupLabel=create.getAttribute('aria-label');
      const motion=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width:640px)');
      const profiles=new Map(scopes.map(button=>[button.dataset.layerScope,{
        button,view:button.dataset.view,
        countries:button.dataset.countries.toUpperCase().split(',').map(c=>c.trim()).filter(c=>/^[A-Z]{2}$/.test(c)),
        order:button.dataset.order.split(',').map(key=>layers.find(l=>l.dataset.key===key.trim())?.dataset.id).filter(Boolean).slice(0,6)
      }]).filter(([,p])=>p.countries.length));
      if(!profiles.size)return;
      const allCountries=[...new Set([...profiles.values()].flatMap(p=>p.countries))];
      const defaultButton=root.querySelector('[data-default-scope]');defaultButton.dataset.layerScope='all';defaultButton.dataset.view='all';scopes.push(defaultButton);
      profiles.set('all',{button:defaultButton,view:'all',countries:['US','GB','ES','AU',...allCountries.filter(c=>!['US','GB','ES','AU'].includes(c))].filter(c=>allCountries.includes(c)),order:layers.filter(l=>['new_in','bestsellers','low_stock','sold_out'].includes(l.dataset.key)).map(l=>l.dataset.id)});
      const names=new Intl.DisplayNames(['en'],{type:'region'}),countryNames={GB:'Great Britain',US:'United States',KR:'South Korea'};
      const countryLabel=code=>countryNames[code]||names.of(code);
      const countryFlag=code=>String.fromCodePoint(...[...code].map(c=>127397+c.charCodeAt(0)));
      const countries=new Map(profiles.get('all').countries.map(code=>{
        const option=document.createElement('option');option.value=code;option.textContent=countryFlag(code)+' '+countryLabel(code);
        const flag=document.createElement('span');flag.setAttribute('aria-hidden','true');flag.textContent=countryFlag(code);
        const choice=document.createElement('label'),checkbox=document.createElement('input');checkbox.type='checkbox';checkbox.name='countries';checkbox.value=code;
        choice.append(checkbox,flag.cloneNode(true),document.createTextNode(countryLabel(code)));members.append(choice);
        return [code,option];
      }));
      const scores=new Map(products.map(product=>{
        try{return [product,JSON.parse(product.dataset.scores||'{}')];}catch{return [product,{}];}
      }));
      const states=new Map();
      let scope='all',country=profiles.get(scope).countries[0];
      let interacted=false,visible=false,timer,drag;
      function previewCountries(id=scope){return profiles.get(id).countries.filter(code=>id!=='all'||!profiles.has('country_'+code));}
      function stateKey(){return scope;}
      function defaultOrder(){return profiles.get(scope).order;}
      function scopeLabel(){return profiles.get(scope).button.textContent;}
      function state(){const key=stateKey();if(!states.has(key))states.set(key,{order:[...defaultOrder()]});return states.get(key);}
      function visibleLayers(){return [...list.children].filter(layer=>!layer.hidden);}
      function capture(nodes){nodes.forEach(node=>node.getAnimations().forEach(a=>a.cancel()));return new Map(nodes.filter(node=>!node.hidden).map(node=>[node,node.getBoundingClientRect()]));}
      function animate(nodes,positions){
        if(motion.matches)return;
        nodes.filter(node=>!node.hidden).forEach(node=>{
          const first=positions.get(node),last=node.getBoundingClientRect();
          if(!first){node.animate([{opacity:0},{opacity:1}],{duration:320});return;}
          const x=first.x-last.x,y=first.y-last.y;
          if(Math.abs(x)+Math.abs(y)>1)node.animate([{transform:'translate('+x+'px,'+y+'px)'},{transform:'translate(0,0)'}],{duration:480,easing:'cubic-bezier(.22,1,.36,1)'});
        });
      }
      function matches(product,layer){
        const d=product.dataset,target=layer.dataset.target.toLowerCase();
        switch(layer.dataset.kind){
          case 'new_in':return Number(d.newness)>=90;
          case 'restock':return d.restocked==='true';
          case 'sale':return d.onSale==='true';
          case 'tags':return d.tags.toLowerCase().split(',').map(t=>t.trim()).includes(target);
          case 'product_type':return d.type.toLowerCase()===target;
          case 'metafield':return d.metafield.toLowerCase()===target;
          case 'bestsellers':return true;
          default:return false;
        }
      }
      function rankProducts(ordered){
        const soldOutIndex=ordered.findIndex(l=>l.dataset.kind==='sold_out'),lowStockIndex=ordered.findIndex(l=>l.dataset.kind==='low_stock');
        const priority=product=>{
          const soldOut=product.dataset.soldOut==='true'||Number(product.dataset.stock)===0;
          if(soldOut&&soldOutIndex!==-1)return soldOutIndex;
          if(!soldOut&&lowStockIndex!==-1&&(product.dataset.brokenStock==='true'||Number(product.dataset.stock)<=5))return lowStockIndex;
          const index=ordered.findIndex(layer=>matches(product,layer));
          return index===-1?ordered.length:index;
        };
        const priorities=new Map(products.map(product=>[product,priority(product)]));
        const score=product=>Number(scores.get(product)[country]??product.dataset.sales);
        return products.slice().sort((a,b)=>{
          const priorityDifference=priorities.get(a)-priorities.get(b);if(priorityDifference)return priorityDifference;
          for(const layer of ordered){
            const difference=layer.dataset.kind==='bestsellers'?score(b)-score(a):Number(matches(b,layer))-Number(matches(a,layer));
            if(difference)return difference;
          }
          return score(b)-score(a)||a.dataset.id.localeCompare(b.dataset.id);
        });
      }
      function previewSample(){
        const configured=defaultOrder().map(id=>layers.find(l=>l.dataset.id===id));
        const season=configured.find(layer=>layer.dataset.kind==='tags'&&['summer','winter'].includes(layer.dataset.target.toLowerCase()));
        const initial=rankProducts(configured).filter(product=>!season||matches(product,season));
        const sold=initial.filter(p=>p.dataset.soldOut==='true'||Number(p.dataset.stock)===0).slice(0,2);
        const low=initial.filter(p=>p.dataset.soldOut!=='true'&&Number(p.dataset.stock)>0&&(p.dataset.brokenStock==='true'||Number(p.dataset.stock)<=5)).slice(0,1);
        const healthy=initial.filter(p=>!sold.includes(p)&&!low.includes(p)&&p.dataset.soldOut!=='true'&&Number(p.dataset.stock)>5);
        return new Set([...healthy.slice(0,(mobile.matches?8:10)-sold.length-low.length),...low,...sold]);
      }
      function revealScope(){
        if(scopeBar.hidden||scopeBar.scrollWidth<=scopeBar.clientWidth)return;
        const button=profiles.get(scope).button,bounds=scopeBar.getBoundingClientRect(),box=button.getBoundingClientRect();
        if(box.left<bounds.left||box.right>bounds.right)scopeBar.scrollTo({left:scopeBar.scrollLeft+box.left-bounds.left-(bounds.width-box.width)/2,behavior:motion.matches?'instant':'smooth'});
      }
      function render(withAnimation=true){
        const layerPositions=capture(layers),productPositions=capture(products),current=state(),profile=profiles.get(scope);
        const availableCountries=previewCountries();
        if(!availableCountries.includes(country))country=availableCountries[0]||'';
        const ordered=current.order.map(id=>layers.find(l=>l.dataset.id===id));
        layers.forEach(layer=>layer.hidden=!current.order.includes(layer.dataset.id));
        ordered.forEach((layer,index)=>{list.append(layer);layer.querySelector('[data-layer-number]').textContent=(index+1)+'.';});
        view.value=profile.view;
        root.dataset.view=profile.view;scopeBar.setAttribute('aria-label',profile.view==='all'?'Country-specific logic':'Country group');
        const createLabel=profile.view==='all'?create.dataset.countryLabel:createGroupLabel;
        create.setAttribute('aria-label',createLabel);create.title=createLabel;
        create.disabled=profile.view==='all'&&allCountries.every(code=>profiles.has('country_'+code));
        scopes.forEach(button=>{button.hidden=button.dataset.view!==profile.view;button.setAttribute('aria-pressed',String(button.dataset.layerScope===scope));});
        countrySelect.replaceChildren(...availableCountries.map(code=>countries.get(code)));countrySelect.value=country;
        countrySelect.disabled=!availableCountries.length;preview.hidden=!availableCountries.length;
        if(!availableCountries.length){const option=document.createElement('option');option.textContent='No countries remaining';countrySelect.append(option);}
        const sample=previewSample();let position=0;
        preview.style.setProperty('--gflh-product-columns',String(Math.max(1,Math.min(mobile.matches?4:5,Math.ceil(sample.size/2)))));
        rankProducts(ordered).forEach(product=>{preview.append(product);product.hidden=!sample.has(product);if(!product.hidden)product.querySelector('[data-layer-rank]').textContent=++position;});
        revealScope();
        if(withAnimation){animate(layers,layerPositions);animate(products,productPositions);}
      }
      function stop(){interacted=true;clearTimeout(timer);}
      function schedule(){
        clearTimeout(timer);
        if(interacted||!visible||document.hidden||motion.matches||root.dataset.autoplay!=='true'||!root.isConnected||root.contains(document.activeElement))return;
        timer=setTimeout(()=>{
          const members=previewCountries(),index=members.indexOf(country);
          if(index<1&&index<members.length-1)country=members[index+1];
          else{const keys=['all',...[...profiles.keys()].filter(id=>id!=='all')].filter(id=>previewCountries(id).length);scope=keys[(keys.indexOf(scope)+1)%keys.length];country=previewCountries()[0];}
          render();schedule();
        },Math.max(4,Number(root.dataset.interval)||5)*1000);
      }
      function selectScope(id){stop();cancelDrag();scope=id;country=previewCountries()[0]||'';render();}
      scopeBar.addEventListener('click',event=>{const button=event.target.closest('[data-layer-scope]');if(button)selectScope(button.dataset.layerScope);});
      view.addEventListener('change',()=>{const id=[...profiles].find(([,p])=>p.view===view.value)?.[0];if(id)selectScope(id);});
      countrySelect.addEventListener('change',()=>{stop();cancelDrag();country=countrySelect.value;render();});
      countrySelect.addEventListener('pointerdown',stop);
      scopeBar.addEventListener('pointerdown',stop);
      const groupName=groupForm.elements.group_name,submit=groupForm.querySelector('[type="submit"]');
      function validateGroup(){submit.disabled=!groupName.value.trim()||members.querySelectorAll('input:checked').length<2;}
      const logicCountry=countryForm.elements.country,logicSubmit=countryForm.querySelector('[type="submit"]');
      create.addEventListener('click',()=>{
        stop();cancelDrag();
        if(profiles.get(scope).view==='all'){
          const available=profiles.get('all').countries.filter(code=>!profiles.has('country_'+code));
          logicCountry.replaceChildren(...available.map(code=>countries.get(code).cloneNode(true)));
          logicCountry.value=available.includes(country)?country:available[0]||'';logicSubmit.disabled=!available.length;
          countryDialog.showModal();logicCountry.focus();return;
        }
        groupForm.reset();validateGroup();dialog.showModal();groupName.focus();
      });
      root.querySelector('[data-country-close]').addEventListener('click',()=>countryDialog.close());
      countryForm.addEventListener('submit',event=>{
        event.preventDefault();const code=logicCountry.value,id='country_'+code;
        if(!allCountries.includes(code)||profiles.has(id))return;
        const button=document.createElement('button');button.type='button';button.dataset.layerScope=id;button.dataset.view='all';button.textContent=countryFlag(code)+' '+countryLabel(code);
        profiles.set(id,{button,view:'all',countries:[code],order:[...(states.get('all')?.order||profiles.get('all').order)]});
        scopes.push(button);scopeBar.append(button);countryDialog.close();selectScope(id);button.focus({preventScroll:true});
        announcement.textContent=countryLabel(code)+' country-specific logic created.';
      });
      groupForm.addEventListener('input',validateGroup);
      root.querySelector('[data-group-close]').addEventListener('click',()=>dialog.close());
      groupForm.addEventListener('submit',event=>{
        event.preventDefault();validateGroup();if(submit.disabled)return;
        const id='custom_'+profiles.size,button=document.createElement('button');button.type='button';button.dataset.layerScope=id;button.dataset.view='custom';button.textContent=groupName.value.trim();button.title=button.textContent;
        profiles.set(id,{button,view:'custom',countries:[...members.querySelectorAll('input:checked')].map(input=>input.value),order:[...state().order]});
        scopes.push(button);scopeBar.append(button);
        if(!view.querySelector('option[value="custom"]')){const option=document.createElement('option');option.value='custom';option.textContent='My country groups';view.append(option);}
        dialog.close();selectScope(id);button.focus({preventScroll:true});
      });
      function moveLayer(layer,index){
        const current=state(),from=current.order.indexOf(layer.dataset.id);if(from<0)return;
        current.order.splice(from,1);current.order.splice(index,0,layer.dataset.id);render();
        announcement.textContent=layer.querySelector('.gflh-layer-title').textContent+', position '+(index+1)+', '+scopeLabel();
      }
      list.addEventListener('click',event=>{
        const button=event.target.closest('[data-layer-delete]');if(!button)return;
        stop();cancelDrag();const layer=button.closest('[data-layer]'),current=state(),index=current.order.indexOf(layer.dataset.id);
        current.order.splice(index,1);render();announcement.textContent=layer.querySelector('.gflh-layer-title').textContent+' layer removed.';
        (visibleLayers()[Math.min(index,current.order.length-1)]?.querySelector('[data-layer-delete]')||(create.disabled?view:create)).focus({preventScroll:true});
      });
      list.addEventListener('keydown',event=>{
        const handle=event.target.closest('[data-layer-grip]');if(!handle)return;
        if(event.key==='Escape'){cancelDrag();render(false);return;}
        if(!['ArrowUp','ArrowDown'].includes(event.key))return;
        event.preventDefault();stop();const layer=handle.closest('[data-layer]'),order=state().order;
        moveLayer(layer,Math.max(0,Math.min(order.length-1,order.indexOf(layer.dataset.id)+(event.key==='ArrowUp'?-1:1))));handle.focus({preventScroll:true});
      });
      function cancelDrag(){
        if(!drag)return;const {layer,clone,id}=drag;drag=null;clone?.remove();layer.classList.remove('is-placeholder');
        if(list.hasPointerCapture(id))list.releasePointerCapture(id);
      }
      list.addEventListener('pointerdown',event=>{
        const handle=event.target.closest('[data-layer-grip]');if(!handle||!event.isPrimary||event.button!==0)return;
        stop();capture(layers);const layer=handle.closest('[data-layer]'),box=layer.getBoundingClientRect();
        drag={layer,handle,id:event.pointerId,startY:event.clientY,offset:event.clientY-box.top};list.setPointerCapture(event.pointerId);
      });
      list.addEventListener('pointermove',event=>{
        if(!drag||event.pointerId!==drag.id)return;
        if(!drag.clone&&Math.abs(event.clientY-drag.startY)<5)return;event.preventDefault();const bounds=root.getBoundingClientRect();
        if(!drag.clone){
          const box=drag.layer.getBoundingClientRect(),clone=drag.layer.cloneNode(true);clone.removeAttribute('data-layer');clone.setAttribute('aria-hidden','true');clone.inert=true;clone.classList.add('is-dragging');
          Object.assign(clone.style,{position:'absolute',left:(box.left-bounds.left)+'px',width:box.width+'px',height:box.height+'px',pointerEvents:'none'});
          root.append(clone);drag.clone=clone;drag.layer.classList.add('is-placeholder');
        }
        drag.clone.style.top=(event.clientY-bounds.top-drag.offset)+'px';
        const rows=visibleLayers(),target=rows.find(row=>{const b=row.getBoundingClientRect();return event.clientY>=b.top&&event.clientY<=b.bottom;});
        if(target&&target!==drag.layer){const index=rows.indexOf(target),positions=capture(rows);list.insertBefore(drag.layer,index>rows.indexOf(drag.layer)?target.nextSibling:target);animate(rows.filter(row=>row!==drag.layer),positions);}
      });
      list.addEventListener('pointerup',event=>{if(!drag||event.pointerId!==drag.id)return;const {layer,clone}=drag,index=visibleLayers().indexOf(layer);cancelDrag();if(clone)moveLayer(layer,index);});
      list.addEventListener('pointercancel',()=>{cancelDrag();render(false);});
      list.addEventListener('lostpointercapture',()=>{if(drag){cancelDrag();render(false);}});
      function resize(){cancelDrag();render(false);}
      root.addEventListener('focusin',schedule);root.addEventListener('focusout',()=>queueMicrotask(schedule));
      document.addEventListener('visibilitychange',schedule);motion.addEventListener('change',schedule);mobile.addEventListener('change',resize);
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.15});observer.observe(root);
      cleanups.set(root,()=>{clearTimeout(timer);cancelDrag();observer.disconnect();document.removeEventListener('visibilitychange',schedule);motion.removeEventListener('change',schedule);mobile.removeEventListener('change',resize);});
      render(false);schedule();
    }
    document.querySelectorAll('[data-features-layers]').forEach(init);
    document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-features-layers]').forEach(init));
    document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-features-layers]').forEach(root=>cleanups.get(root)?.()));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["geosort-hero-rules-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    const cleanups = new WeakMap();
    function init(section) {
      if (section.dataset.gfhReady === "true") return;
      section.dataset.gfhReady = "true";
      const rules = Array.from(section.querySelectorAll("[data-gfh-rule]"));
      const preview = section.querySelector("[data-gfh-preview]");
      const products = Array.from(section.querySelectorAll("[data-gfh-product]"));
      const markets = Array.from(section.querySelectorAll("[data-gfh-market]"));
      if (!preview || !markets.length) return;
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      const marketStates = new Map();
      const defaults = rules.map(rule => rule.getAttribute("aria-checked") === "true");
      let activeMarket = markets[0].dataset.gfhMarket;
      let paused = section.dataset.autoplay !== "true" || reducedMotion.matches;
      let visible = false;
      let timer;
      let drag = null;
      const interval = Math.max(3, Number(section.dataset.autoplayInterval) || 5) * 1000;
      function schedule() {
        clearTimeout(timer);
        if (paused || !visible || !section.isConnected || document.hidden || section.contains(document.activeElement)) return;
        timer = setTimeout(() => {
          activeMarket = markets[(markets.findIndex(button => button.dataset.gfhMarket === activeMarket) + 1) % markets.length].dataset.gfhMarket;
          reorder();
          schedule();
        }, interval);
      }
      function pause() { paused = true; schedule(); }
      function pinAt(product, slot) {
        pause();
        const order = Array.from(preview.children);
        order.splice(order.indexOf(product), 1);
        order.splice(slot, 0, product);
        const pins = state().pins;
        pins.set(product.dataset.productId, slot);
        order.forEach((item, index) => {
          if (pins.has(item.dataset.productId)) pins.set(item.dataset.productId, index);
        });
        reorder();
        section.querySelector('[data-gfh-announcement]').textContent = product.querySelector('.gfh-product-title').textContent + ', pinned to position ' + (slot + 1) + ' in ' + markets.find(button => button.dataset.gfhMarket === activeMarket).textContent.trim();
      }
      function state() {
        if (!marketStates.has(activeMarket)) {
          marketStates.set(activeMarket, { enabled: defaults.slice(), pins: new Map() });
        }
        return marketStates.get(activeMarket);
      }
      function reorder(animate = true) {
        products.forEach(product => product.getAnimations().forEach(animation => animation.cancel()));
        const firstPositions = new Map(products.map(product => [product, product.getBoundingClientRect()]));
        const current = state();
        const enabledKinds = rules.filter((rule, index) => current.enabled[index]).map(rule => rule.dataset.gfhRule);
        const scoreKey = "score" + activeMarket[0].toUpperCase() + activeMarket.slice(1);
        const sorted = products.slice().sort((a, b) => {
          if (enabledKinds.includes("sold_out") && a.dataset.soldOut !== b.dataset.soldOut) {
            return Number(a.dataset.soldOut === "true") - Number(b.dataset.soldOut === "true");
          }
          for (const kind of enabledKinds) {
            let difference = 0;
            if (kind === "new_in") difference = Number(b.dataset.newness) - Number(a.dataset.newness);
            if (kind === "sale") difference = Number(b.dataset.onSale === "true") - Number(a.dataset.onSale === "true");
            if (kind === "bestsellers") difference = Number(b.dataset[scoreKey] || b.dataset.sales) - Number(a.dataset[scoreKey] || a.dataset.sales);
            if (difference) return difference;
          }
          return products.indexOf(a) - products.indexOf(b);
        });
        const order = new Array(products.length);
        current.pins.forEach((slot, id) => {
          const product = products.find(item => item.dataset.productId === id);
          if (product) order[slot] = product;
        });
        const unpinned = sorted.filter(product => !current.pins.has(product.dataset.productId));
        for (let index = 0; index < order.length; index++) {
          if (!order[index]) order[index] = unpinned.shift();
        }
        order.forEach((product, index) => {
          preview.appendChild(product);
          product.querySelector("[data-gfh-rank]").textContent = index + 1;
          const pinned = current.pins.has(product.dataset.productId);
          product.classList.toggle("is-pinned", pinned);
          product.querySelector("[data-gfh-pin]").setAttribute("aria-pressed", String(pinned));
        });
        rules.forEach((rule, index) => rule.setAttribute("aria-checked", String(current.enabled[index])));
        markets.forEach(button => button.setAttribute("aria-pressed", String(button.dataset.gfhMarket === activeMarket)));
        if (!animate || reducedMotion.matches) return;
        products.forEach(product => {
          const first = firstPositions.get(product);
          const last = product.getBoundingClientRect();
          const dx = first.left - last.left;
          const dy = first.top - last.top;
          if (Math.abs(dx) + Math.abs(dy) < 1) return;
          product.animate([
            { transform: "translate(" + dx + "px," + dy + "px)" },
            { transform: "translate(0,0)" }
          ], { duration: 560, easing: "cubic-bezier(0.22,1,0.36,1)" });
        });
      }
      rules.forEach((rule, index) => {
        rule.addEventListener("click", () => {
          pause();
          state().enabled[index] = !state().enabled[index];
          reorder();
        });
      });
      markets.forEach(button => button.addEventListener("click", () => {
        pause();
        activeMarket = button.dataset.gfhMarket;
        reorder();
      }));
      section.addEventListener("focusin", schedule);
      section.addEventListener("focusout", () => queueMicrotask(schedule));
      document.addEventListener("visibilitychange", schedule);
      const motionChange = () => { if (reducedMotion.matches) pause(); };
      reducedMotion.addEventListener("change", motionChange);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold: .15});
      observer.observe(section);
      cleanups.set(section, () => { clearTimeout(timer);observer.disconnect();document.removeEventListener("visibilitychange",schedule);reducedMotion.removeEventListener("change",motionChange);cancelDrag(); });
      function cancelDrag() {
        if (!drag) return;
        drag.product.classList.remove('is-dragging');
        if (drag.product.hasPointerCapture(drag.pointerId)) drag.product.releasePointerCapture(drag.pointerId);
        products.forEach(item => item.classList.remove('is-drop-target'));
        drag = null;
      }
      preview.addEventListener('dragstart', event => event.preventDefault());
      preview.addEventListener('pointerdown', event => {
        const product = event.target.closest('[data-gfh-product]');
        if (!product || event.target.closest('button') || !event.isPrimary || event.button !== 0) return;
        pause();
        products.forEach(item => item.getAnimations().forEach(animation => animation.cancel()));
        drag = {product, pointerId:event.pointerId, x:event.clientX, y:event.clientY, active:false, target:null};
        product.setPointerCapture(event.pointerId);
      });
      preview.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.pointerId) return;
        if (!drag.active && Math.hypot(event.clientX-drag.x,event.clientY-drag.y) < 7) return;
        drag.active = true;
        drag.product.classList.add('is-dragging');
        const target = document.elementFromPoint(event.clientX,event.clientY)?.closest('[data-gfh-product]');
        drag.target = target && preview.contains(target) ? target : null;
        products.forEach(item => item.classList.toggle('is-drop-target', item === drag.target && item !== drag.product));
      });
      preview.addEventListener('pointerup', event => {
        if (!drag || event.pointerId !== drag.pointerId) return;
        const {product,target,active} = drag;
        const slot = target ? Array.from(preview.children).indexOf(target) : -1;
        cancelDrag();
        if (active && slot >= 0 && target !== product) pinAt(product,slot);
      });
      preview.addEventListener('pointercancel', cancelDrag);
      preview.addEventListener('lostpointercapture', cancelDrag);
      preview.addEventListener('keydown', event => {
        const product = event.target.closest('[data-gfh-product]');
        if (!product || event.target !== product) return;
        if (event.key === 'Escape') {cancelDrag();return;}
        const columns = getComputedStyle(preview).gridTemplateColumns.split(' ').length;
        const delta = {ArrowLeft:-1,ArrowRight:1,ArrowUp:-columns,ArrowDown:columns}[event.key];
        if (!delta) return;
        event.preventDefault();
        const slot = Math.max(0,Math.min(products.length-1,Array.from(preview.children).indexOf(product)+delta));
        pinAt(product,slot);
        product.focus({preventScroll:true});
      });
      preview.addEventListener("click", event => {
        const button = event.target.closest("[data-gfh-pin]");
        if (!button) return;
        pause();
        const product = button.closest("[data-gfh-product]");
        const id = product.dataset.productId;
        const pins = state().pins;
        if (pins.has(id)) pins.delete(id);
        else pins.set(id, Array.from(preview.children).indexOf(product));
        reorder();
      });
      reorder(false);
      schedule();
    }
    document.querySelectorAll("[data-geosort-rules-preview]").forEach(init);
    document.addEventListener("shopify:section:load", event => {
      event.target.querySelectorAll("[data-geosort-rules-preview]").forEach(init);
    });
    document.addEventListener("shopify:section:unload", event => event.target.querySelectorAll("[data-geosort-rules-preview]").forEach(section => cleanups.get(section)?.()));
  })();
  } catch(e) { console.error(e); }
})();

})();
